<template>
  <div id="landing">
   <!--<div
      class="md-layout md-gutter md-alignment-center-center"
      style="margin-top: 60px"
    >
      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-33 md-small-size-50 md-xsmall-size-100" style="margin-top:30px">
         <div class="md-layout md-gutter md-alignment-center-center">
            <md-button style="width:187.5px;height:181.5px;"
              href="./dashboard"
              :target="openBlank?'_blank':'_self'"
              class="md-raised md-primary module-link"
              v-if="permissions.includes('dashboard')"
            >
              <div class="module-icon icon-chart"></div>
            </md-button>
            <div class="module-name">Dashboard</div>
         </div>
      </div>
      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-if="permissions.includes('send')" style="margin-top:30px">
         <div class="md-layout md-gutter md-alignment-center-center">
            <md-button style="width:187.5px;height:181.5px;" href="./send" :target="openBlank?'_blank':'_self'" class="md-raised md-primary module-link">
              <div class="module-icon icon-contract"></div>
            </md-button>
            <div class="module-name">Create new</div>
          </div>
      </div>
      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-if="permissions.includes('adminLog')" style="margin-top:30px">
         <div class="md-layout md-gutter md-alignment-center-center">
            <md-button style="width:187.5px;height:181.5px;" href="./log" :target="openBlank?'_blank':'_self'" class="md-raised md-primary module-link">
              <div class="module-icon icon-note_block"></div>
            </md-button>
            <div class="module-name">Admin log</div>
         </div>
      </div>
      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-if="permissions.includes('config')" style="margin-top:30px">
         <div class="md-layout md-gutter md-alignment-center-center">
        <md-button style="width:187.5px;height:181.5px;" href="./config" :target="openBlank?'_blank':'_self'" class="md-raised md-primary module-link">
          <div class="module-icon icon-gearwheels"></div>
        </md-button>
        <div class="module-name">Config</div>
         </div>
      </div>
      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-if="permissions.includes('security')" style="margin-top:30px">
         <div class="md-layout md-gutter md-alignment-center-center">
            <md-button style="width:187.5px;height:181.5px;" class="md-raised md-primary module-link">
              <div class="module-icon icon-shield"></div>
            </md-button>
            <div class="module-name">Security</div>
         </div>
      </div>

      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-if="permissions.includes('templates')" style="margin-top:30px">
         <div class="md-layout md-gutter md-alignment-center-center">
        <md-button style="width:187.5px;height:181.5px;" href="./templateManager" :target="openBlank?'_blank':'_self'" class="md-raised md-primary module-link">
          <div class="module-icon icon-documents_exchange"></div>
        </md-button>
        <div class="module-name">Template manager</div>
         </div>
      </div>
      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-33 md-small-size-50 md-xsmall-size-100"  v-if="permissions.includes('users')" style="margin-top:30px">
         <div class="md-layout md-gutter md-alignment-center-center">
        <md-button style="width:187.5px;height:181.5px;" href="./users" :target="openBlank?'_blank':'_self'" class="md-raised md-primary module-link">
          <div class="module-icon icon-users"></div>
        </md-button>
        <div class="module-name">User management</div>
         </div>
      </div>
      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-if="permissions.includes('search')" style="margin-top:30px">
         <div class="md-layout md-gutter md-alignment-center-center">
        <md-button style="width:187.5px;height:181.5px;" href="./search" :target="openBlank?'_blank':'_self'" class="md-raised md-primary module-link">
          <div class="module-icon icon-magnifying_glass"></div>
        </md-button>
        <div class="module-name">Search &amp; Reports</div>
         </div>
      </div>
      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-if="permissions.includes('tutorials')" style="margin-top:30px">
         <div class="md-layout md-gutter md-alignment-center-center">
        <md-button style="width:187.5px;height:181.5px;" href="./tutorials" class="md-raised md-primary module-link">
          <div class="module-icon icon-presentation_chart"></div>
        </md-button>
        <div class="module-name">Tutorials</div>
         </div>
      </div>
      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-if="permissions.includes('email_template')" style="margin-top:30px">
         <div class="md-layout md-gutter md-alignment-center-center">
        <md-button style="width:187.5px;height:181.5px;" href="./email_template" :target="openBlank?'_blank':'_self'" class="md-raised md-primary module-link">
          <div class="module-icon icon-email_template"></div>
        </md-button>
        <div class="module-name">Email templates</div>
         </div>
      </div>
    </div> -->
    <div
      >
        <div
          class="md-layout md-gutter md-alignment-center-center"
          style="margin: 10px 0 30px 0"
        >
          <span class="md-display-2" style="font-size: 25px"
            >Pending Transactions for {{ userFullName }}</span
          >
        </div>
        <tasks-table :searchFilters="pendingFilters" :pendingOnly="true" />
      </div>
    <!-- <div
      class="md-layout md-gutter"
      style="margin-top: 30px; max-height: 400px"
    >
      <div
        class="
          md-layout-item
x          md-xl it15
          md-xlarge-size-75
x          md-la 15
          md-large-size-75
          md-medium-size-100
          md-small-size-100
        "
      >
        <div
          class="md-layout md-gutter md-alignment-center-center"
          style="margin: 30px 0px"
        >
          <span class="md-display-2" style="font-size: 25px"
            >Pending Transactions for {{ userFullName }}</span
          >
        </div>
        <sign-table
        :enableDelete="true" :searchFilters="transactionsData" @transactionIdChanged="transactionIdChanged"
        ></sign-table>
      </div>
       <div
        class="
          md-layout-item
x          md-xl it15
          md-xlarge-size-25
x          md-la 15
          md-large-size-25
          md-medium-size-100
          md-small-size-100
        "
      >
        <sign-audit :transactionId="auditTransactionId"></sign-audit>
      </div>
    </div> -->
  </div>
</template>

<script>

import Vue from "vue";
import moment from "moment";
// import SignTable from "../components/SignTable.vue";
// import SignAudit from "../components/SignAudit.vue";
import TasksTable from '../components/TasksTable.vue'
export default {
  name: "Dashboard",
  components: {
    // SignTable,
    TasksTable,
    // SignAudit,
  },
  data() {
    return {
      pendingFilters: {
        userId: Vue.prototype.$userData.user.id,
      status:[1, 2, 3, 4, 5]
      },
      openBlank: localStorage.getItem('openBlank')=='true',
      auditTransactionId: null,
      transactionsData :  {
        userId: Vue.prototype.$userData.user.id,
        status: [1, 2, 3],
        dateInit: moment().add(-10, "years").format("YYYY-MM-DDT00:00:00Z"),
        dateEnd: moment().format("yyyy-MM-DDT23:59:59Z"),
        creators:  [Vue.prototype.$userData.user.id]
      },
    };
  },
  methods: {
    transactionIdChanged(transactionId) {
      this.auditTransactionId = transactionId + "";
    },

  },
  created(){
  },
  computed: {
    userFullName: {
      cache: false,
      get() {
        return (
          Vue.prototype.$userData.user.firstName +
          " " +
          Vue.prototype.$userData.user.lastName
        );
      },
    },
    userEmail: {
      cache: false,
      get() {
        return Vue.prototype.$userData.user.email;
      },
    },
    permissions: {
      cache: false,
      get() {
      

        let userData=Vue.prototype.$userData;
        if(!userData){

           let localUserData=localStorage.getItem('userData');
           userData= localUserData ?JSON.parse(localUserData):{user:{},tokens:{access:{},refresh:{}}};
        }



        const permissions = userData.permissions|| [];
        return permissions;
      },
    },
  },
};
</script>

<style lang="scss">
#landing {
  .module-link {
    height: 10vw;
    width: 10vw;

    border-radius: 10px;

    span {
      font-size: 1.05em;
      letter-spacing: 1px;
      font-weight: 700;
      word-wrap: break-word !important;
    }

    .md-button-content {
      height: 100%;
      width: 100%;
    }
  }
  .md-dialog-title {
    background-color: #e94e1b;
    margin: 0px;
    padding: 20px;
    color: white;
  }

  .md-selected-row {
    background-color: #dddddd !important;
  }
  .md-progress-bar.md-determinate.md-theme-default {
    background-color: #8b7b7b !important;
    height: 8px;
  }
  .md-progress-bar.md-theme-default.md-determinate.md-danger-date
    .md-progress-bar-fill {
    background-color: #97261e !important;
  }
  .md-progress-bar.md-theme-default.md-determinate.md-alert-date
    .md-progress-bar-fill {
    background-color: #d86901 !important;
  }

  .md-content.md-table-content.md-theme-default {
    background-color: transparent !important;
  }
  .md-content.md-table.md-theme-default {
    background-color: transparent !important;
  }
}

.module-name {
  width: 100%;
  text-align: center;
  font-family: "Montserrat", Avenir, Helvetica, Arial, sans-serif;
  /* font-weight: bold; */
  color: #e94e1b;
  font-size: 16px;
  margin-top: 5px;
}

.module-icon {
  width: 171.5px;
  height: 171.5px;
  display: block;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.icon-chart {
  background-image: url(../assets/icons/chart_area.svg);
}
.icon-contract {
  background-image: url(../assets/icons/contract.svg);
}
.icon-documents_exchange {
  background-image: url(../assets/icons/documents_exchange.svg);
}
.icon-gearwheels {
  background-image: url(../assets/icons/gearwheels.svg);
}
.icon-magnifying_glass {
  background-image: url(../assets/icons/magnifying_glass.svg);
}
.icon-note_block {
  background-image: url(../assets/icons/note_block.svg);
}
.icon-notebook {
  background-image: url(../assets/icons/notebook.svg);
}
.icon-presentation_chart {
  background-image: url(../assets/icons/presentation_chart.svg);
}
.icon-shield {
  background-image: url(../assets/icons/shield.svg);
}
.icon-users {
  background-image: url(../assets/icons/users.svg);
}
.icon-email_template {
  background-image: url(../assets/icons/mail2.svg);
}
</style>